module.exports = __webpack_public_path__ + "media/reskin-images/icon--smartphone-update-2-687c1a26.svg";